import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import moment from 'moment';
import { Component } from 'react';
import { propBool, propShape } from '../../../../helpers/custom-prop-types';
import BlurText from '../../../Ui/Common/BlurText';
import SplitText from '../../../Ui/Common/SplitText';
class SectionCareerOne extends Component {
    constructor(props) {
        super(props);
        this.getState = (props) => {
            const { record: { content, date, position, title }, } = props;
            const momentDate = moment(date);
            return {
                content,
                date: `${momentDate.year()}/${`0${(momentDate.month() + 1).toString()}`.slice(-2)}`,
                title: title + (position ? `（${position}）` : ''),
            };
        };
        this.renderFunc = (row) => {
            const { isBlur } = this.props;
            return (_jsx(BlurText, Object.assign({ component: 'span', isBlur: isBlur }, { children: row })));
        };
        this.state = this.getState(props);
    }
    shouldComponentUpdate(nextProps) {
        const { record } = this.props;
        if (record !== nextProps.record) {
            this.setState(this.getState(nextProps));
        }
        return true;
    }
    render() {
        const { isBlur } = this.props;
        const { content, date, title } = this.state;
        return (_jsxs(_Fragment, { children: [_jsx(BlurText, Object.assign({ className: '', component: 'dd', isBlur: isBlur }, { children: date })), _jsxs("dt", { children: [_jsx(BlurText, Object.assign({ component: 'h3', isBlur: isBlur }, { children: title })), _jsx(SplitText, { renderFunc: this.renderFunc, text: content, wrap: 'p' })] })] }));
    }
}
SectionCareerOne.propTypes = {
    isBlur: propBool().isRequired,
    record: propShape(),
};
SectionCareerOne.defaultProps = {
    record: {},
};
export default SectionCareerOne;
